import Node from './shared/Node';

export default class Options extends Node {
	type: 'Options';
}
